import { type MutableRefObject } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { logger } from '@fiverr-private/obs';
import { useEventListener } from '@fiverr-private/hooks';
import { PACKAGE_CLASSNAME } from '@fiverr-private/header';
import { useScrollCallback } from '../../../../../shared/hooks/useScrollCallback/useScrollCallback';
import { toggleCategoriesMenu } from '../../../../../shared/utils/categoriesMenuToggler';

export const useCategoriesToggle = (triggerRef: MutableRefObject<HTMLElement | null>) => {
    const { isMobile } = getContext();
    const callback = (_event?: Event, unsubscribe?: () => void) => {
        if (isMobile) {
            return;
        }
        const header = document.querySelector<HTMLElement>(`header.${PACKAGE_CLASSNAME}`);
        if (!header) {
            logger.error({
                message: 'Header element not found. CategoriesMenu will be always rendered as a safe fallback',
            });
            toggleCategoriesMenu(true);
            unsubscribe?.();
            return;
        }
        if (!triggerRef.current) {
            logger.error({
                message: 'Scroll trigger element not found. CategoriesMenu will be always rendered as a safe fallback',
            });
            toggleCategoriesMenu(true);
            unsubscribe?.();
            return;
        }
        const triggerRect = triggerRef.current.getBoundingClientRect();
        const headerRect = header.getBoundingClientRect();
        toggleCategoriesMenu(triggerRect.bottom < headerRect.bottom);
    };
    useScrollCallback(!isMobile ? callback : undefined);
    useEventListener('load', callback, typeof window !== 'undefined' ? window : null);
};
